import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-sub-header',
  templateUrl: './app-sub-header.component.html',
  styleUrls: ['./app-sub-header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppSubHeaderComponent implements OnInit {

  private resourceBaseUrl = environment.resourceBase;

  constructor(private _router: Router) { }

  ngOnInit() {
  }


  downloadPlanGuide() {
    const fullUrl = `${this.resourceBaseUrl }/eprove-strategies/user-guides/guidebook.pdf`;
    window.open(fullUrl, '_blank');
  }

  goToResources() {
    const currentPath = this._router.url;
    const resourcesUrl = window.location.href.replace(currentPath, '/resources');
    window.open(resourcesUrl);
  }
}
